<template>
  <v-dialog
    v-model="dialogModel"
    persistent
    max-width="560"
  >
    <v-card class="admin-migration-card">
      <div class="admin-migration-card__accent" />

      <v-card-title class="admin-migration-card__title pt-6 px-8 pb-2">
        {{ menuConfig.title }}
      </v-card-title>

      <v-card-text class="px-8 pb-2">
        <div class="admin-migration-card__badge mb-4">
          Novo ambiente
        </div>

        <p
          class="admin-migration-card__text mb-4"
          v-html="menuConfig.descriptionHtml"
        />

        <div class="admin-migration-card__notice">
          {{ menuConfig.notice }}
        </div>
      </v-card-text>

      <v-card-actions class="px-8 pb-6 pt-4 justify-end">
        <v-btn
          outlined
          height="44"
          class="admin-migration-card__btn mr-2"
          @click="close"
        >
          Fechar
        </v-btn>
        <v-btn
          height="44"
          color="var(--red)"
          class="white--text admin-migration-card__btn"
          @click="goToNewAdmin"
        >
          Ir para o novo admin
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  getMigratedMenuConfig,
  getMigratedMenuRedirectUrl,
} from '@/helpers/migratedMenus';

export default {
  name: 'AdminMigrationModal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    menuKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    dialogModel: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue);
      },
    },
    menuConfig () {
      return getMigratedMenuConfig(this.menuKey);
    },
    newAdminUrl () {
      return getMigratedMenuRedirectUrl(this.menuKey);
    },
  },
  methods: {
    close () {
      this.dialogModel = false;
      this.$emit('close');
    },
    goToNewAdmin () {
      if (!this.newAdminUrl) {
        return;
      }

      window.open(this.newAdminUrl, '_blank', 'noopener,noreferrer');
      this.close();
    },
  },
};
</script>

<style lang="scss">
.admin-migration-card {
  overflow: hidden;
  border-radius: 8px !important;

  &__accent {
    height: 4px;
    background: linear-gradient(90deg, var(--dark-red) 0%, var(--default-black) 100%);
  }

  &__title {
    color: var(--black);
    font-size: 22px !important;
    line-height: 1.35 !important;
    font-weight: 700 !important;
    word-break: break-word;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 999px;
    background: var(--grey-day-020);
    color: var(--black);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  &__text {
    color: var(--grey-day);
    font-size: 15px;
    line-height: 1.55;
    margin-bottom: 0;

    strong {
      color: var(--black);
    }
  }

  &__notice {
    padding: 14px 16px;
    border-radius: 8px;
    background: rgba(34, 130, 243, 0.08);
    border: 1px solid rgba(34, 130, 243, 0.2);
    color: #1f3a5f;
    font-size: 14px;
    line-height: 1.5;
  }

  &__btn {
    text-transform: none !important;
    letter-spacing: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminMigrationModal.vue